import React, { FC } from "react";
import { useField } from "formik";
import Select, { SelectChangeEvent, SelectProps } from "../Select";

type FormikSelectProps = {
  name: string;
  onChangeValue?: (value: unknown) => void;
} & Omit<
  SelectProps,
  | "type"
  | "value"
  | "multiline"
  | "onChange"
  | "onBlur"
  | "error"
  | "helperText"
>;

const FormikSelect: FC<FormikSelectProps> = ({
  name,
  children,
  onChangeValue,
  ...props
}) => {
  const [field, meta] = useField(name);
  const { touched, error } = meta;

  const onSelectValue = (e: SelectChangeEvent<unknown>) => {
    field.onChange(e);

    if (onChangeValue) {
      onChangeValue(e.target.value);
    }
  };

  return (
    <Select
      {...props}
      {...field}
      onChange={onSelectValue}
      error={touched && Boolean(error)}
    >
      {children}
    </Select>
  );
};

export default FormikSelect;
